var map = {
	"./ADA.png": 6671,
	"./AERGO.png": 1881,
	"./ALGO.png": 2146,
	"./ANIME.png": 6131,
	"./ANKR.png": 1685,
	"./ARDR.png": 7708,
	"./ARK.png": 9283,
	"./ATOM.png": 2480,
	"./BAT.png": 2970,
	"./BCH.png": 6860,
	"./BLUR.png": 7016,
	"./BONK.png": 2783,
	"./BOUNTY.png": 7402,
	"./BSC.png": 1359,
	"./BTC.png": 8118,
	"./BTT.png": 1161,
	"./CVC.png": 1045,
	"./DOGE.png": 2028,
	"./ELF.png": 8156,
	"./EOS.png": 6528,
	"./ETC.png": 2425,
	"./ETH.png": 170,
	"./GAME2.png": 6099,
	"./GAS.png": 8588,
	"./GMT.png": 9223,
	"./GRS.png": 1677,
	"./HIFI.png": 7749,
	"./ICX.png": 2891,
	"./IOST.png": 1394,
	"./IOTA.png": 8978,
	"./IQ.png": 1561,
	"./JUP.png": 2538,
	"./KNC.png": 4821,
	"./LOOM.png": 4612,
	"./LSK.png": 8725,
	"./MANA.png": 3334,
	"./MBL.png": 1011,
	"./ME.png": 9377,
	"./MEW.png": 6090,
	"./MOC.png": 2968,
	"./MTL.png": 6342,
	"./NEO.png": 2241,
	"./ONG.png": 6373,
	"./ONT.png": 1838,
	"./PEPE.png": 1355,
	"./POL.png": 2290,
	"./POLYX.png": 4005,
	"./POWR.png": 5655,
	"./QKC.png": 2184,
	"./QTUM.png": 4006,
	"./SC.png": 89,
	"./SEI.png": 4734,
	"./SHIB.png": 3047,
	"./SNT.png": 7698,
	"./SOL.png": 7709,
	"./STEEM.png": 2567,
	"./STORJ.png": 2599,
	"./SUI.png": 1326,
	"./TFUEL.png": 2227,
	"./THETA.png": 5367,
	"./TRUMP.png": 1331,
	"./TRX.png": 6961,
	"./TT.png": 8955,
	"./USDC.png": 9544,
	"./USDT.png": 2951,
	"./WAVES.png": 2257,
	"./XEM.png": 2449,
	"./XLM.png": 7602,
	"./XRP.png": 2013,
	"./ZIL.png": 2690,
	"./ZRX.png": 8895,
	"./none.png": 3981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9776;